type NotificationRow = { id: string; title: string; body: string; read_at: string | null; created_at: string; deal_id: string | null };

export function OpsPaperworkNotificationsTab(props: {
  notifications: NotificationRow[];
  onMarkAllRead: () => Promise<void>;
}) {
  return (
    <div className="space-y-2">
      <button type="button" className="text-sm border rounded px-2 py-1" onClick={() => void props.onMarkAllRead()}>
        Mark all read
      </button>
      <ul className="divide-y divide-gray-100">
        {props.notifications.map((n) => (
          <li key={n.id} className={`py-2 text-sm ${n.read_at ? "opacity-60" : ""}`}>
            <div className="font-medium">{n.title}</div>
            <div className="text-xs text-gray-600">{n.body}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}

